(function () {
  document.querySelectorAll('[data-coa-lookup]').forEach(function (root) {
    var input = root.querySelector('[data-coa-input]');
    var findBtn = root.querySelector('[data-coa-find]');
    var result = root.querySelector('[data-coa-result]');
    var entries = Array.prototype.map.call(root.querySelectorAll('[data-coa-entry]'), function (el) {
      return {
        name: el.getAttribute('data-name') || '',
        method: el.getAttribute('data-method') || '',
        supplier: el.getAttribute('data-supplier') || '',
        link: el.getAttribute('data-link') || ''
      };
    });

    function search() {
      var query = (input.value || '').trim().toLowerCase();
      if (!query) {
        input.focus();
        return;
      }
      var match = entries.find(function (e) {
        return e.name.toLowerCase().indexOf(query) > -1 || query.indexOf(e.name.toLowerCase()) > -1;
      });

      result.classList.remove('notfound');
      if (match) {
        result.innerHTML =
          '<div class="row1">\u2713 COA available</div>' +
          '<div class="grid2">' +
          '<div><b>Product</b>' + match.name + '</div>' +
          '<div><b>Method</b>' + match.method + '</div>' +
          '<div><b>Supplied by</b>' + match.supplier + '</div>' +
          '</div>' +
          (match.link ? '<a class="dl" href="' + match.link + '" target="_blank" rel="noopener">Download COA (PDF)</a>' : '');
      } else {
        result.classList.add('notfound');
        result.innerHTML = '<div class="row1">No exact match found</div><div class="grid2"><div>Try the exact product name, or contact us and we\'ll send the COA directly.</div></div>';
      }
      result.classList.add('show');
    }

    findBtn.addEventListener('click', search);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') search();
    });
  });
})();
